import { IApplicationState } from 'shared/types/redux';
import { ILandingState } from 'shared/types/features';

export const selectCalculatorValues = (state: IApplicationState): ILandingState['calculatorValues'] =>
  state.landing.calculatorValues;
